<template>
  <router-view></router-view>
</template>

<script>
    export default {
        //二级菜单的页面，没有用处
        name: "Second"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/Second.vue